module.exports = __webpack_public_path__ + "img/800-Interactive-Email-Image.c9686b87.jpg";